import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Esito } from 'src/app/common/models/esito';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { OperationsService } from 'src/app/core/services/operations.service';
import {
  SezioneEconomicaLiquidatiFormComponent
} from '../../../form/sez-economica/sezione-economica-liquidati-form.component';
import { SezioneEconomicaResponse } from '../../../models/dto/sezione-economica-response';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { Liquidato } from '../../../models/liquidato';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';


@Component({
    selector: 'div [sezione-economica-liquidati-form-add]',
  templateUrl: '../../../form/sez-economica/sezione-economica-liquidati-form.component.html'
})

export class SezioneEconomicaLiquidatiAddComponent extends SezioneEconomicaLiquidatiFormComponent implements OnInit {
  liquidato: Liquidato;
  urlUpdate: string;

  @Output() onReturn: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>();

  constructor(protected operationService: OperationsService,
              protected campiForm: FormBuilder,
              protected helpers: HelpersService) {
    super(operationService, campiForm, helpers);
  }

  ngOnInit() {
    this.isInserimento(true);
  }

  getLiquidato() {
    return new Liquidato();
  }

  getRequest(request: Liquidato, esito: Esito) {
    request.idEsito = esito.id;
    this.operationService.addLiquidati(this.urlUpdate, request, this.sezione ? this.sezione.id : 'new', this.fascicolo.id).subscribe((response: any) => this.datiSezioneEconomica(response));
  }

  datiSezioneEconomica(response: SezioneEconomicaResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(sezione: SezioneEconomica, liquidato: Liquidato, fascicolo: FascicoloFull, urlUpdate: string, isViewTerzoPignorato: boolean, idSezioneEsiti: string, urlReadSezioneEsiti: string) {
    this.fascicolo = fascicolo;
    this.isViewTerzoPignorato = isViewTerzoPignorato;
    this.liquidato = liquidato ? liquidato : new Liquidato();
    this.idSezioneEsiti = idSezioneEsiti;
    this.urlReadSezioneEsiti = urlReadSezioneEsiti;
    this.readSezioneEsiti(idSezioneEsiti, urlReadSezioneEsiti);
    this.sezione = sezione;
    this.urlUpdate = urlUpdate;
    this.initViewToggle();
    this.populateSelect();
    this.createForm();
  }

}
